import React, { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";

import {
	changeStep,
	getFlatsInfo,
	changeActiveFloor,
	changeActiveSection,
} from "../../store/visualSlice";

export const FloorsVisualStep = ({ complexId }) => {
	const [tooltipData, setTooltipData] = useState({});
	const [tooltipShow, setTooltipShow] = useState(false);
	const [tooltipCoordinate, setTooltipCoordinate] = useState({});
	const [nextBtnShow, setNextBtnShow] = useState(false);

	const isEnglish = document.body.classList.contains("en");
	const complexName = document
		.querySelector("section.chooser")
		?.getAttribute("data-complex-name")
		.toLowerCase();

	const floors = useRef();
	const floorsFilter = useRef();

	const dispatch = useDispatch();
	const { activeFloor } = useSelector((state) => state.visual);

	useEffect(() => {
		document.querySelector("section.chooser.visual").classList.add("floors");
	}, []);

	useEffect(() => {
		for (let floor of floors.current.childNodes) {
			floor.addEventListener("mouseenter", (e) => {
				floor.style.fillOpacity = "0.6";
				floor.style.cursor = "pointer";

				setTooltipShow(true);

				setTooltipData(
					complexName === "essence"
						? { floor: floor.getAttribute("data-floor") }
						: { building: floor.getAttribute("data-building") }
				);
			});

			floor.addEventListener("mouseleave", (e) => {
				floor.style.fillOpacity = "0";

				setTooltipShow(false);
			});

			floor.addEventListener("mousemove", (e) => {
				setTooltipCoordinate({ x: e.offsetX, y: e.offsetY });
			});

			floor.addEventListener("click", (e) => {
				let floorNumber = floor.getAttribute("data-floor");

				if (floorNumber === "7") {
					floorNumber = "7";
				}

				dispatch(getFlatsInfo({ complexId, floorNumber }));
				dispatch(changeActiveFloor(floorNumber));

				complexName !== "essence" &&
					floor.getAttribute("data-section") &&
					dispatch(changeActiveSection(floor.getAttribute("data-section")));

				dispatch(changeStep("flats"));
				document
					.querySelector("section.chooser.visual")
					.classList.remove("floors");
			});
		}

		floorsFilter.current.addEventListener("click", (evt) => {
			const target = evt.target;

			if (target.closest("li")) {
				const targetItem = target.closest("li");

				floorsFilter.current.childNodes.forEach((item) =>
					item.classList.remove("active")
				);
				floors.current.childNodes.forEach(
					(item) => (item.style.fillOpacity = "0")
				);

				let activeNumber = targetItem.getAttribute("data-number");
				targetItem.classList.add("active");

				if (activeNumber === "7") {
					activeNumber = "7";
				}

				dispatch(changeActiveFloor(activeNumber));
				setNextBtnShow(true);
			}
		});

		() => {
			floorsFilter.current.removeEventListener("click", () => {});

			for (let floor of floors.current.childNodes) {
				floor.removeEventListener("mouseenter", () => {});
				floor.removeEventListener("mouseleave", () => {});
				floor.removeEventListener("mousemove", () => {});
				floor.removeEventListener("click", () => {});
			}
		};
	}, [floors]);

	useEffect(() => {
		for (let floor of floors.current.childNodes) {
			if (
				floor.getAttribute("data-floor") === activeFloor ||
				(floor.getAttribute("data-floor") === "7" && activeFloor === "7")
			) {
				floor.style.fillOpacity = "0.6";
			}
		}
	}, [activeFloor]);

	const onNextStep = () => {
		dispatch(changeStep("flats"));
		document.querySelector("section.chooser.visual").classList.remove("floors");
	};

	const showVisual = () => {
		location.href = "/projects/" + complexName + "/apartments/";
	};

	const isMainPage =
		location.pathname === "/projects/" + complexName + "/apartments/";

	return (
		<>
			{isMainPage && (
				<>
					<div class="visual-header">
						<a href="/projects/essence/">
							{isEnglish ? "To project page" : "На страницу проекта"}
						</a>
						<h1>{complexName}</h1>
					</div>
				</>
			)}

			{complexName == "essence" ? (
				<div className="floor">
					<ul className="floors-filter" ref={floorsFilter}>
						<li data-number="1">
							<button type="button">1 {isEnglish ? "floor" : "Этаж"}</button>
						</li>
						<li data-number="2">
							<button type="button">2 {isEnglish ? "floor" : "Этаж"}</button>
						</li>
						<li data-number="3">
							<button type="button">3 {isEnglish ? "floor" : "этаж"}</button>
						</li>
						<li data-number="4">
							<button type="button">4 {isEnglish ? "floor" : "этаж"}</button>
						</li>
						<li data-number="5">
							<button type="button">5 {isEnglish ? "floor" : "этаж"}</button>
						</li>
						<li data-number="6">
							<button type="button">6 {isEnglish ? "floor" : "этаж"}</button>
						</li>
						<li data-number="7">
							<button type="button">7 {isEnglish ? "floor" : "этаж"}</button>
						</li>
					</ul>
					<button
						className="plan dark stroke"
						onClick={onNextStep}
						style={{ display: `${nextBtnShow ? "flex" : "none"}` }}
						type="button"
					>
						{isEnglish ? "View floor plan" : "Посмотреть поэтажный план"}
					</button>
					<div className="visual-floors">
						<picture>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								preserveAspectRatio="xMidYMid slice"
								width="100%"
								height="1080"
								fill="none"
								viewBox="0 0 1920 1080"
							>
								<image
									width="100%"
									height="1080"
									className=""
									xlinkHref="/images/complex/essence/visual/essence_render_new.webp"
								></image>
								<g className="Essence">
									<g ref={floors}>
										<path
											fill="#fff"
											fillOpacity="0"
											d="m1607 318-94.5-42H1499l-60.5-28.5-419 45-43-24.5-31.5 3.5v135.02L983 422l14-2.5 6.5 5 19-2.5.35.17 35.65 16.77L1398 396.5l4 2v7l52.5 27.5 107.71-15.46.65-12.98 40.25-4.02L1607 318Zm-677 84.5V383l-2-1v-7l-19-13v-46.5l-56-36-115.5 11.31V293l-253 26-2.5-3.17L296.5 334v32.5H291l.5 10 5 5.5 5.62 102.88L359 549l85.5-9 15 15.5 129.57-16.2-1.5-45.22L908.64 456l.18-25h7.68l2.8-5 .2-22.25 10.5-1.25Z"
											data-floor="7"
										/>
										<path
											fill="#fff"
											fillOpacity="0"
											d="m997 419.5-14 2.5-38-15.48v37.38l38.08 15.93 14-2.5 6.5 5 18.67-2.5 35.83 16.75 338.75-43.66 4 2v7l52.09 28.41 107.41-15.3.71-14.13 40.36-4.27 1.71-36.1-40.25 4.03-.65 12.98L1454.5 433l-52.5-27.5v-7l-4-2-339.5 42.44-35.65-16.77-.35-.17-19 2.5-6.5-5ZM444.5 540l-85.5 9-56.88-64.12 2.19 40.24 57.36 65.71 84.33-9.91 14.75 15.33 129.6-18.33-1.28-38.62-129.57 16.2-15-15.5Zm464.05-70.5h10.34l.18-19.5c0-.4-6.83-12.83-10.25-19l-.18 25-321.07 38.08 1.33 40.3 319.47-39.13.18-25.75Z"
											data-floor="6"
										/>
										<path
											fill="#fff"
											fillOpacity="0"
											d="m997.08 457.33-14 2.5L945 443.9v37.39l38.17 16.38 14-2.5 6.5 5 18.33-2.5 36.17 16.5 337.5-44.84 4 2v7l51.66 29.34 107.12-15.14.76-15.3 40.49-4.51 1.7-36.1-40.36 4.28-.71 14.14-107.41 15.3-52.09-28.42v-7l-4-2-338.75 43.66-35.83-16.75-18.67 2.5-6.5-5ZM362.83 631.67l84.67-9.84L462 637l129.72-17.53-1.37-41.55-129.6 18.33L446 580.92l-84.33 9.91-57.36-65.7 2.2 40.22 56.32 66.32ZM908.28 508h10.25l.2-21-6.73-14h-3.47l-.16 22.25L588.9 534.4l1.34 40.3 318.1-40.19-.06-26.5Z"
											data-floor="5"
										/>
										<path
											fill="#fff"
											fillOpacity="0"
											d="m997.17 495.17-14 2.5L945 481.29v37.39l38.25 16.82 14-2.5 6.5 5 18-2.5 36.5 16.25 336.25-46 4 2v7l51.25 30.25 106.81-14.97.83-16.47 40.61-4.75 1.7-36.1-40.49 4.52-.76 15.3-107.12 15.14-51.66-29.34v-7l-4-2-337.5 44.84-36.17-16.5-18.33 2.5-6.5-5ZM364 672.5l85-9.75 14.25 15 129.85-16.72-1.38-41.56L462 637l-14.5-15.17-84.67 9.84-56.32-66.32 2.19 40.2L364 672.5ZM907.83 573l.2-27.5h10.16l.2-21-6.39-14h-3.71l.04 24-318.09 40.2 1.34 40.3 316.25-42Z"
											data-floor="4"
										/>
										<path
											fill="#fff"
											fillOpacity="0"
											d="m997.25 533-14 2.5L945 518.68v37.4l38.33 17.25 14-2.5 6.5 5 17.67-2.5 15.77 6.85 19.73-2.68v-6.67h4.5l21.91 14.97 309.92-43.63 4 2v7l50.84 31.16 106.51-14.8.88-17.64 40.73-5 1.71-36.08-40.61 4.75-.83 16.47L1449.75 545l-51.25-30.25v-7l-4-2-336.25 46-36.5-16.25-18 2.5-6.5-5ZM366.33 712.5l84.17-8.83 14 14.83 129.98-15.92-1.38-41.55-129.85 16.72-14.25-15-85 9.75-55.3-66.96 2.25 41.18 55.38 65.78Zm541.69-167-.19 27.5-316.25 42 1.33 40.3L907.56 612l.2-29.5h10.08l.2-22-8.04-15h-1.98Z"
											data-floor="3"
										/>
										<path
											fill="#fff"
											fillOpacity="0"
											d="m997.33 570.83-14 2.5L945 556.08V586h1.5l5.75 5.75 85.02-11.57-15.77-6.85-17.67 2.5-6.5-5Zm400-26.66-4-2-309.92 43.63 39.09 26.7v5.14l269.67-39.06 4 2v7l50.41 32.09 106.22-14.65.94-18.8 40.85-5.23 1.7-36.1-40.73 5-.88 17.63-106.51 14.81-50.84-31.16v-7ZM368.5 755l83.5-10.42 13.75 14.67 130.1-15.11-.23-7.14-1.14-34.42L464.5 718.5l-14-14.83-84.17 8.83-55.38-65.78 2.2 40.3L368.5 755Zm539.01-135.5h9.99l.2-22.5-7.7-14.5h-2.23l-.2 29.5-314.66 43.3 1.34 40.32 313.04-43.26.22-32.86Z"
											data-floor="2"
										/>
										<path
											fill="#fff"
											fillOpacity="0"
											d="m1391 615 4 2v7l49.85 32.9 106.06-14.39 1.01-19.97 40.97-5.46 1.7-36.09-40.85 5.23-.94 18.8-106.22 14.65-50.41-32.09v-7l-4-2-269.67 39.06v37.33L1391 615ZM315 721h10l21.5 26v27l18.5 20 18.5-2.5 2 2.5 69-8.5 12.4 14.5 130.16-17.5-1.22-38.36-130.09 15.11L452 744.58 368.5 755l-55.35-67.98L315 721Zm280.62 16L907 694.5l.29-42.14-313.04 43.25 1.37 41.39Z"
											data-floor="1"
										/>
									</g>
									{isEnglish ? (
										<g className="Text">
											<path
												fill="#fff"
												d="M420.82 291v-23.1h10.15c4.05-.05 6.95 2.57 6.9 6.04a5.44 5.44 0 0 1-3.85 5.35c2.51.48 4.33 2.5 4.33 5.52.07 3.53-3.1 6.24-7.04 6.19h-10.49Zm3.96-13.44h5.61c2.2 0 3.51-1.13 3.51-3.08 0-1.93-1.3-3.04-3.5-3.04h-5.62v6.12Zm0 9.91h5.87c2.34 0 3.75-1.16 3.75-3.24s-1.41-3.22-3.75-3.22h-5.87v6.46Zm17.36-2.27v-10.7h3.8v10.13c0 2.34.97 3.58 2.82 3.58h.26c1.95.05 3.77-2 3.72-4.65v-9.06h3.8V291h-3.8v-2.72a5.43 5.43 0 0 1-5.01 3.04c-3.7 0-5.6-2.5-5.6-6.12Zm18.88-13.2v-4.1h4.13v4.1h-4.13Zm.16 19v-16.5h3.8V291h-3.8Zm8.45 0v-23.1h3.8V291h-3.8Zm7.49-8.25c-.05-4.83 2.96-8.65 7.36-8.57 2.24 0 4.14 1.2 4.92 2.54v-8.83h3.79V291h-3.8v-2.22c-.76 1.32-2.8 2.54-5.05 2.54-4.38.07-7.27-3.7-7.22-8.57Zm7.86 5.46h.28c2.12.05 4.19-2.1 4.14-5.46.05-3.35-2.02-5.5-4.14-5.46h-.28c-2.32 0-4.07 2.01-4.07 5.44 0 3.42 1.75 5.48 4.07 5.48Zm12.68-16.2v-4.12h4.13V272h-4.13Zm.16 18.99v-16.5h3.8V291h-3.8Zm8.45 0v-16.5h3.8v2.37a5.8 5.8 0 0 1 5.1-2.7c3.83 0 5.84 2.44 5.84 6.05V291h-3.8v-10.2c0-2.26-.98-3.51-2.92-3.51h-.25c-2.15 0-3.97 1.91-3.97 4.5V291h-3.8Zm18.01 1.98h3.79c.26 1.34 1.74 2.16 3.98 2.16h.26a4.3 4.3 0 0 0 3.08-1.11c.78-.73 1.17-1.8 1.17-3.24v-2.24a5.43 5.43 0 0 1-4.77 2.45c-3.85.05-7.28-3.05-7.22-8.41-.06-5.4 3.3-8.46 7.22-8.41 1.05 0 2 .22 2.85.66a4.4 4.4 0 0 1 1.92 1.79v-2.13h3.8v16.73c.05 3.78-3.09 7.1-8.34 7.04-4.4.03-7.56-2.21-7.74-5.29Zm8.06-5.09h.26c2.1.05 4.01-2.08 3.96-5.3 0-3.29-1.75-5.3-3.9-5.3h-.26c-2.24 0-4.02 1.82-4.02 5.3 0 3.48 1.72 5.3 3.96 5.3Zm36.25 3.11-2.19-5.66h-10.26l-2.18 5.66h-4.12l9.15-23.1h4.79l8.97 23.1h-4.15Zm-11.08-9.2h7.52l-3.77-9.76-3.75 9.76Z"
												class="Building A"
											/>
											<path
												fill="#fff"
												d="M1105.06 245v-23.1h10.15c4.04-.06 6.94 2.57 6.89 6.04a5.43 5.43 0 0 1-3.85 5.35c2.52.48 4.34 2.5 4.34 5.52.06 3.53-3.1 6.24-7.04 6.19h-10.49Zm3.96-13.44h5.61c2.21 0 3.51-1.13 3.51-3.08 0-1.93-1.3-3.04-3.51-3.04h-5.61v6.12Zm0 9.91h5.87c2.33 0 3.75-1.16 3.75-3.24s-1.42-3.22-3.75-3.22h-5.87v6.46Zm17.35-2.27v-10.7h3.81v10.13c0 2.34.96 3.58 2.82 3.58h.25c1.95.05 3.78-2 3.73-4.65v-9.06h3.8V245h-3.8v-2.72a5.44 5.44 0 0 1-5.01 3.04c-3.71 0-5.6-2.5-5.6-6.12Zm18.89-13.2v-4.1h4.12v4.1h-4.12Zm.16 19v-16.5h3.8V245h-3.8Zm8.44 0v-23.1h3.81V245h-3.81Zm7.5-8.25c-.05-4.83 2.96-8.65 7.36-8.57 2.24 0 4.14 1.2 4.91 2.54v-8.83h3.79V245h-3.79v-2.22c-.77 1.32-2.8 2.54-5.05 2.54-4.39.07-7.27-3.7-7.22-8.57Zm7.86 5.46h.27c2.13.05 4.19-2.1 4.14-5.46.05-3.35-2.01-5.5-4.14-5.46h-.27c-2.32 0-4.08 2.01-4.08 5.44 0 3.42 1.76 5.48 4.08 5.48Zm12.68-16.2v-4.12h4.13V226h-4.13Zm.16 18.99v-16.5h3.8V245h-3.8Zm8.45 0v-16.5h3.8v2.37a5.8 5.8 0 0 1 5.11-2.7c3.81 0 5.83 2.44 5.83 6.05V245h-3.8v-10.2c0-2.26-.99-3.51-2.92-3.51h-.26c-2.14 0-3.96 1.92-3.96 4.5V245h-3.8Zm18.01 1.98h3.79c.25 1.34 1.74 2.16 3.98 2.16h.25c1.28 0 2.31-.37 3.08-1.11.79-.73 1.18-1.8 1.18-3.24v-2.24a5.43 5.43 0 0 1-4.77 2.45c-3.85.05-7.28-3.04-7.22-8.41-.06-5.4 3.3-8.46 7.22-8.41 1.05 0 2 .22 2.85.66a4.4 4.4 0 0 1 1.92 1.79v-2.13h3.8v16.73c.05 3.78-3.09 7.1-8.35 7.04-4.39.03-7.55-2.21-7.73-5.29Zm8.06-5.09h.25c2.12.05 4.02-2.08 3.97-5.3 0-3.29-1.76-5.3-3.9-5.3h-.26c-2.24 0-4.03 1.82-4.03 5.3 0 3.48 1.73 5.3 3.97 5.3Zm21.02 3.11v-23.1h10.16c4.04-.06 6.94 2.57 6.89 6.04a5.43 5.43 0 0 1-3.85 5.35c2.51.48 4.34 2.5 4.34 5.52.06 3.53-3.1 6.24-7.05 6.19h-10.49Zm3.97-13.44h5.61c2.2 0 3.51-1.13 3.51-3.08 0-1.93-1.31-3.04-3.51-3.04h-5.61v6.12Zm0 9.91h5.86c2.34 0 3.76-1.16 3.76-3.24s-1.42-3.22-3.76-3.22h-5.86v6.46Z"
												class="Building B"
											/>
										</g>
									) : (
										<g className="Text">
											<path
												fill="#fff"
												d="m434.31 279.3-3.4 3.53v6.96H427V267h3.91v10.68L441.24 267h4.93l-9.05 9.4 9.22 13.4h-4.84l-7.19-10.5Zm20.62 10.8c-4.57.07-8.06-3.58-8-8.45-.06-4.86 3.43-8.51 8-8.45 4.6-.06 8.08 3.6 8.01 8.45.07 4.87-3.41 8.52-8 8.46Zm-4.23-8.45c0 3.39 1.66 5.4 4.1 5.4h.28c2.44 0 4.1-2.01 4.1-5.4 0-3.38-1.66-5.38-4.1-5.38h-.27c-2.45 0-4.1 2-4.1 5.38Zm16.2-8.13h3.74v2.19c.74-1.3 2.77-2.51 4.98-2.51 4.34-.06 7.18 3.65 7.13 8.45.05 4.77-2.94 8.54-7.27 8.46-2.2 0-4.1-1.2-4.84-2.51v8.7h-3.75v-22.78Zm3.74 8.13c-.04 3.31 1.96 5.44 4.09 5.4h.25c2.3 0 4.02-2.01 4.02-5.4 0-3.38-1.73-5.38-4.02-5.38h-.25c-2.13-.04-4.13 2.08-4.09 5.38Zm16.06-8.13H501v16.27h-3.76v-13.24h-6.79v13.24h-3.75v-16.27Zm26.4 20.01c-.8 1.97-1.82 2.6-4.04 2.6h-4.4v-3.27h3.5c1.12 0 1.45-.22 1.82-1.2l1.02-2.63-7.31-15.51h4.11l5.04 10.74 4.16-10.74h4.04l-7.94 20Zm17.31-3.43c-4.6.07-7.87-3.5-7.82-8.45-.05-4.94 3.23-8.51 7.82-8.45 4.04 0 6.72 2.08 7.04 5.88h-3.75c-.27-1.73-1.4-2.81-3.16-2.81h-.27c-2.64 0-3.93 2.38-3.93 5.38s1.29 5.4 3.93 5.4h.27c1.76 0 2.9-1.09 3.16-2.82h3.75c-.32 3.8-3 5.88-7.04 5.88Zm32.33-5.89H552.6l-2.14 5.58h-4.07l9.03-22.79h4.72l8.85 22.8h-4.1l-2.16-5.59Zm-8.77-3.5h7.42l-3.72-9.63-3.7 9.64Z"
												className="ÐÐ¾ÑÐ¿ÑÑ A"
											/>
											<path
												fill="#fff"
												d="m1116.41 235.46-3.45 3.58v7.05H1109V223h3.96v10.82l10.47-10.82h4.99l-9.16 9.52 9.33 13.57h-4.91l-7.27-10.63Zm20.89 10.95c-4.64.07-8.17-3.64-8.1-8.56-.07-4.93 3.46-8.63 8.1-8.57 4.65-.06 8.18 3.64 8.11 8.57.07 4.92-3.46 8.63-8.11 8.56Zm-4.29-8.56c0 3.43 1.68 5.45 4.16 5.45h.27c2.48 0 4.16-2.03 4.16-5.45 0-3.43-1.68-5.46-4.16-5.46h-.27c-2.48 0-4.16 2.03-4.16 5.46Zm16.4-8.25h3.8v2.22c.74-1.32 2.8-2.54 5.04-2.54 4.4-.06 7.28 3.7 7.23 8.57.05 4.83-2.98 8.64-7.37 8.56-2.23 0-4.16-1.2-4.9-2.54v8.82h-3.8V229.6Zm3.8 8.25c-.05 3.34 1.98 5.5 4.14 5.45h.26c2.32 0 4.07-2.03 4.07-5.45 0-3.43-1.75-5.46-4.07-5.46h-.26c-2.16-.03-4.19 2.1-4.14 5.46Zm16.27-8.25h14.48v16.49h-3.8v-13.41h-6.88v13.4h-3.8V229.6Zm26.74 20.27c-.81 2-1.84 2.64-4.09 2.64h-4.46v-3.31h3.56c1.12 0 1.46-.23 1.83-1.21l1.03-2.67-7.4-15.72h4.17l5.1 10.89 4.22-10.89h4.09l-8.05 20.27Zm17.54-3.46c-4.65.07-7.97-3.56-7.92-8.56-.05-5.01 3.27-8.63 7.92-8.57 4.09 0 6.81 2.1 7.13 5.96h-3.8c-.27-1.76-1.42-2.85-3.2-2.85h-.28c-2.67 0-3.97 2.41-3.97 5.46 0 3.04 1.3 5.45 3.97 5.45h.28c1.78 0 2.93-1.1 3.2-2.85h3.8c-.32 3.85-3.04 5.96-7.13 5.96Zm29.86-23.41c4.05-.05 6.94 2.58 6.9 6.04a5.43 5.43 0 0 1-3.85 5.34c2.51.49 4.33 2.5 4.33 5.53.06 3.52-3.09 6.23-7.04 6.18h-10.48V223h10.14Zm-6.18 19.56h5.86c2.34 0 3.75-1.16 3.75-3.23 0-2.08-1.41-3.22-3.75-3.22h-5.86v6.45Zm0-9.9h5.61c2.2 0 3.51-1.13 3.51-3.07s-1.31-3.05-3.51-3.05h-5.61v6.12Z"
												className="ÐÐ¾ÑÐ¿ÑÑ Ð"
											/>
										</g>
									)}
								</g>
							</svg>
						</picture>
						<span
							className="floor dark stroke"
							style={{
								transform: `translateX(${
									tooltipCoordinate.x - 45
								}px) translateY(${tooltipCoordinate.y - 50}px)`,
								display: `${tooltipShow ? "block" : "none"}`,
							}}
						>
							{tooltipData.floor} {isEnglish ? "floor" : "этаж"}
						</span>
					</div>
				</div>
			) : (
				<div className="floor">
					<ul className="floors-filter" ref={floorsFilter}>
						<li data-number="1">
							<button type="button">
								{isEnglish ? "Building A: Wave" : "Корпус A – «Волна»"}
							</button>
						</li>
						<li data-number="2">
							<button type="button">
								{isEnglish ? "Building B: Rhythm" : "Корпус B – «Ритм»"}
							</button>
						</li>
						<li data-number="3">
							<button type="button">
								{isEnglish ? "Building C: Ethnica" : "Корпус C – «Этника»"}
							</button>
						</li>
					</ul>
					<button
						className="plan dark stroke"
						onClick={onNextStep}
						style={{ display: `${nextBtnShow ? "flex" : "none"}` }}
						type="button"
					>
						{isEnglish ? "View floor plan" : "Посмотреть поэтажный план"}
					</button>
					<div className="visual-floors">
						<picture>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								preserveAspectRatio="xMidYMid slice"
								width="100%"
								height="1080"
								fill="none"
								viewBox="0 0 1920 1080"
							>
								<image
									width="100%"
									height="1080"
									className=""
									xlinkHref="/styles/images/chooser/bamboo_forest.webp"
								></image>
								<g className="bamboo-forest">
									<g ref={floors}>
										<path
											fill="#fff"
											fillOpacity="0"
											data-floor="1"
											data-building={
												isEnglish ? "Building A: Wave" : "Корпус A – «Волна»"
											}
											data-section="a"
											d="M300.358 124.358a4.174 4.174 0 0 0-4.014 4.17v9.617a4.17 4.17 0 0 1-3.984 4.169l-25.498 1.141a4.173 4.173 0 0 0-3.971 3.834l-1.982 24.646a3.834 3.834 0 0 1-3.188 3.476 3.835 3.835 0 0 0-3.198 3.643l-.819 22.521c-.047 1.293-.834 2.231-1.925 2.926-.915.582-1.731 1.766-1.731 5.052 0 5.089 1.959 20.087 3.205 28.272a2.083 2.083 0 0 1-2.054 2.399c-1.109 0-2.023.874-2.017 1.984.022 4.408.598 11.286 2.326 20.968 1.442 8.082 2.745 18.772 3.367 25.913.197 2.257-1.729 2.046-3.993 2.046-.806 0-2.711-.626-2.711 2.504 0 3.129 3.337 26.707 3.337 31.923 0 5.216-7.508 11.267-7.508 17.735 0 8.968 9.627 46.385 12.654 57.934a4.149 4.149 0 0 0 4.414 3.075l16.256-1.549c3.034-.289 5.344 2.671 4.326 5.546l-11.783 33.321a4.168 4.168 0 0 0-.107 2.432l4.197 16.315a4.17 4.17 0 0 0 4.522 3.104l5.955-.695a3.87 3.87 0 0 1 4.043 2.409c.366.913.37 1.93.012 2.846l-12.318 31.58a4.188 4.188 0 0 0-.173 2.48l3.658 15.435a4.172 4.172 0 0 0 4.456 3.191l8.411-.806c3.278-.314 5.61 3.12 4.111 6.054l-14.714 28.795a4.18 4.18 0 0 0-.239 3.232l4.826 14.327a4.173 4.173 0 0 0 4.434 2.813l12.442-1.445c3.271-.38 5.672 3.006 4.232 5.969l-14.386 29.604a4.174 4.174 0 0 0-.318 2.74l3.034 13.511c.225 1 .809 1.882 1.642 2.479a4.166 4.166 0 0 0 2.875.756l216.042-23.288a20.017 20.017 0 0 0 11.644-5.393l2.515-2.39a20.013 20.013 0 0 1 12.078-5.435l16.13-1.384a17.143 17.143 0 0 1 11.114 2.912 17.14 17.14 0 0 0 10.516 2.953l90.331-4.566a3.49 3.49 0 0 0 3.29-3.112 3.483 3.483 0 0 1 3.195-3.105l137.943-10.743a4.168 4.168 0 0 0 3.847-4.161v-74.102c0-.928.31-1.83.879-2.562l9.555-12.291c.57-.733.879-1.634.879-2.562v-13.12l-2.069-42.643a4.178 4.178 0 0 0-3.1-3.832l-30.348-8.03a4.167 4.167 0 0 1-3.1-3.865l-8.38-207.11a4.173 4.173 0 0 0-.86-2.375l-71.971-93.645a4.057 4.057 0 0 0-3.208-1.581h-2.641c-.777 0-1.406.63-1.406 1.407 0 .763-.607 1.387-1.368 1.407l-12.04.322a4.156 4.156 0 0 1-3.486-1.719l-7.549-10.398a4.178 4.178 0 0 0-3.605-1.714l-345.183 19.062a4.173 4.173 0 0 0-3.941 4.166v3.509a4.173 4.173 0 0 1-4.013 4.17l-21.794.826Z"
										/>
										<path
											fill="#fff"
											fillOpacity="0"
											data-floor="2"
											data-building={
												isEnglish
													? "Building C: Ethnica"
													: "Корпус C – «Этника»"
											}
											data-section="c"
											d="m828.203 420.707 2.117 43.644a4.08 4.08 0 0 0 1.788 3.203c8.162 5.487 26.326 16.553 45.859 24.928 15.462 6.63 30.329 9.076 40.03 9.712 3.268.215 4.803-3.51 2.54-5.879a3.861 3.861 0 0 1-1.07-2.669v-19.733a4.174 4.174 0 0 1 4.171-4.173h9.868c.361 0 .71.129.983.364.981.84 2.495.143 2.495-1.149V414.03c0-9.359 23.49-15.086 38.084-17.248 2.074-.307 3.639-2.057 3.66-4.153l.971-100.611a4.173 4.173 0 0 1 3.825-4.119l45.256-3.758a4.153 4.153 0 0 0 2.68-1.29 4.16 4.16 0 0 0 1.14-2.752l.41-14.536a4.164 4.164 0 0 1 1.26-2.875 4.158 4.158 0 0 1 2.9-1.181h1.3c2.25 0 4.1-1.782 4.17-4.03l.63-18.22a4.151 4.151 0 0 0-1.39-3.256l-2.99-2.67a4.258 4.258 0 0 1-1.02-1.407 4.186 4.186 0 0 1-.37-1.706v-2.819c0-.822.32-1.614.88-2.215a3.227 3.227 0 0 1 2.14-1.026l.31-.021c.74-.05 1.43-.378 1.93-.918.51-.539.79-1.25.79-1.989v-1.558c0-.749.6-1.356 1.35-1.356.75 0 1.36.607 1.36 1.356v1.174c0 .345.07.686.21 1.003.13.316.33.602.59.838.25.237.54.419.87.537.32.118.66.168 1.01.148l7.38-.44a4.162 4.162 0 0 0 3.91-4.166v-17.743c0-.283-.11-.555-.31-.755-.2-.201-.32-.472-.32-.756v-.133c0-.733.57-1.339 1.3-1.388l61.52-4.052a4.18 4.18 0 0 0 3.9-3.957l.67-13.644a4.207 4.207 0 0 1 1.19-2.721 4.18 4.18 0 0 1 2.71-1.237l178.83-11.634c.98-.063 1.9-.466 2.6-1.139a4.148 4.148 0 0 0 1.27-2.543l7.2-61.786c.07-.585.01-1.178-.17-1.74a4.23 4.23 0 0 0-.86-1.519 4.18 4.18 0 0 0-3.12-1.397h-2.11c-.61 0-1.21.132-1.75.386l-5.42 2.51c-2.21 1.027-4.71-.745-4.47-3.178a3.18 3.18 0 0 0-.68-2.28 3.166 3.166 0 0 0-2.07-1.165l-46.93-5.98a4.171 4.171 0 0 1-3.62-4.574l.61-5.826c.12-1.09-.2-2.182-.89-3.039a4.166 4.166 0 0 0-2.76-1.539l-220.02-25.909a4.184 4.184 0 0 0-1.8.183l-82.898 27.445a1.9 1.9 0 0 0-1.303 1.803 1.9 1.9 0 0 1-1.262 1.79l-30.581 10.874a4.17 4.17 0 0 0-2.775 3.932V91.4a4.175 4.175 0 0 1-2.814 3.946L895.38 98a4.17 4.17 0 0 0-2.815 3.946v12.128a4.17 4.17 0 0 1-2.637 3.881l-1.828.723c-2.16.855-4.502-.738-4.502-3.063v-2.25a1.045 1.045 0 0 0-1.78-.738 1.045 1.045 0 0 0-.306.738v6.646c0 .663-.359 1.274-.938 1.596a1.819 1.819 0 0 0-.939 1.595v3.491c0 .737.533 1.366 1.26 1.487.72.12 1.25.738 1.26 1.468l.361 26.895a4.173 4.173 0 0 1-2.706 3.964l-6.227 2.336a4.17 4.17 0 0 0-2.706 3.907v9.327a4.177 4.177 0 0 1-2.595 3.864l-5.371 2.193a3.628 3.628 0 0 0-2.223 3.831 3.623 3.623 0 0 0 3.142 3.119l.165.021a3.814 3.814 0 0 1 3.336 3.782v4.916c0 1.682-1.01 3.2-2.561 3.85l-26.784 11.209a4.177 4.177 0 0 0-2.562 3.85v12.03a4.17 4.17 0 0 1-2.486 3.817l-10.951 4.839a4.173 4.173 0 0 0-2.482 4.019l8.698 179.29v.001Z"
										/>
										<path
											fill="#fff"
											fillOpacity="0"
											data-floor="3"
											data-building={
												isEnglish ? "Building B: Rhythm" : "Корпус B – «Ритм»"
											}
											data-section="b"
											d="m1313.19 160.52-182.3 11.86a4.18 4.18 0 0 0-2.71 1.237 4.207 4.207 0 0 0-1.19 2.721l-.67 13.644a4.168 4.168 0 0 1-1.2 2.721 4.175 4.175 0 0 1-2.7 1.236l-61.52 4.052c-.73.048-1.3.655-1.3 1.388v.133c0 .284.12.555.32.756.2.2.31.472.31.755v17.743a4.166 4.166 0 0 1-3.91 4.166l-7.38.44c-.35.02-.69-.03-1.01-.148-.33-.118-.62-.3-.87-.537a2.327 2.327 0 0 1-.59-.838 2.479 2.479 0 0 1-.21-1.003v-1.174c0-.749-.61-1.356-1.36-1.356-.75 0-1.35.607-1.35 1.356v1.558c0 .739-.28 1.45-.79 1.989-.5.54-1.19.868-1.93.918l-.31.021c-.82.058-1.58.424-2.14 1.026a3.258 3.258 0 0 0-.88 2.215v2.819c0 1.189.5 2.322 1.39 3.113l2.99 2.67a4.151 4.151 0 0 1 1.39 3.256l-.63 18.22a4.137 4.137 0 0 1-1.27 2.86 4.134 4.134 0 0 1-2.9 1.17h-1.29a4.164 4.164 0 0 0-2.91 1.181 4.164 4.164 0 0 0-1.26 2.875l-.41 14.536a4.16 4.16 0 0 1-1.14 2.752 4.153 4.153 0 0 1-2.68 1.29l-45.256 3.758a4.167 4.167 0 0 0-3.825 4.119l-.971 100.61c-.021 2.097-1.586 3.847-3.66 4.154-14.594 2.162-38.084 7.889-38.084 17.248v54.925c0 1.292-1.514 1.989-2.495 1.149a1.507 1.507 0 0 0-.983-.364h-9.869a4.174 4.174 0 0 0-4.171 4.173v19.608c0 1.074.415 2.107 1.157 2.884l5.622 5.884 5.621 5.884a4.176 4.176 0 0 1 1.156 2.884v13.975a2.504 2.504 0 0 1-2.502 2.504 2.506 2.506 0 0 0-2.503 2.503v38.745c0 1.575.886 3.016 2.292 3.725l10.397 5.251c2.413 1.218 1.547 4.859-1.155 4.859a2.567 2.567 0 0 0-2.567 2.568v15.505c0 .866.269 1.71.77 2.416 5.803 8.189 15.225 21.666 19.685 28.61 1.407 2.19.09 4.316-2.513 4.316h-8.974a4.17 4.17 0 0 0-4.171 4.173v18.658c0 .891.27 1.736.794 2.456 39.834 54.614 92.375 170.342 109.285 279.951.09.565.29 1.107.59 1.592.3.485.7.904 1.17 1.231.47.327 1 .556 1.56.673a4.2 4.2 0 0 0 1.69.005c24.14-4.798 70.46-11.376 93.04-4.944 21.73 6.19 52.94 16.943 69.66 22.904a4.173 4.173 0 0 0 3.55-.349 4.21 4.21 0 0 0 2-2.964l2.15-14.202c.42-2.779 3.41-4.383 6.03-3.371 10.72 4.134 29.65 9.126 47.99 6.745 20.99-2.725 67.37-11.44 90.47-15.947a4.192 4.192 0 0 0 2.15-1.144c.58-.588.98-1.338 1.13-2.153l3.89-20.124a4.16 4.16 0 0 1 3.6-3.351l82.9-9.952a4.14 4.14 0 0 0 3.49-2.945l3.43-11.417c.23-.787.7-1.487 1.33-2.012.63-.525 1.4-.852 2.22-.939l199.77-21.35c.75-.08 1.46-.36 2.06-.81.6-.45 1.07-1.053 1.36-1.747l7.6-18.421c.53-1.27 1.64-2.2 2.99-2.488l68.31-14.649a4.156 4.156 0 0 0 3.17-3.038l3.95-15.31c.18-.734.17-1.505-.05-2.232a4.2 4.2 0 0 0-1.18-1.892l-42.81-39.093c-2.8-2.551-.99-7.204 2.79-7.204a4.133 4.133 0 0 0 2.47-.821 4.205 4.205 0 0 0 1.5-2.135l5.57-18.646a4.18 4.18 0 0 0-1.52-4.553l-55.08-40.707a4.205 4.205 0 0 1-1.49-2.081 4.147 4.147 0 0 1 0-2.56l.49-1.533c.53-1.631 2-2.774 3.72-2.88l71.62-4.455c.81-.05 1.58-.332 2.23-.811a4.194 4.194 0 0 0 1.42-1.889l5.34-14.245c.34-.913.35-1.918.03-2.84a4.138 4.138 0 0 0-1.79-2.202l-43.39-26.079c-3.42-2.055-2.28-7.28 1.69-7.724l57.63-6.463c.8-.089 1.56-.409 2.18-.921a4.098 4.098 0 0 0 1.33-1.962l18.16-57.2c.51-1.582.03-3.319-1.28-4.331-5.29-4.075-14.81-9.83-22.92-9.541-11.67.417-26.27 10.433-40.04 1.252-8.69-5.801-12.24-10.769-13.34-14.143-.41-1.254.65-2.34 1.97-2.34 1.16 0 2.14-.826 2.35-1.961l.15-.827a3.46 3.46 0 0 0-.11-1.66 3.426 3.426 0 0 0-.89-1.406l-1.21-1.159a4.116 4.116 0 0 1-1.15-1.935c-.2-.739-.2-1.518.02-2.253l5.27-18.096c.18-.609.08-1.265-.25-1.804a2.033 2.033 0 0 1-.32-.852c-.04-.303-.03-.613.06-.908l8.29-30.82a4.17 4.17 0 0 1 4.03-3.087h.27c.96 0 1.9-.334 2.64-.946a4.16 4.16 0 0 0 1.45-2.409l.44-2.192a4.21 4.21 0 0 0-.26-2.453 4.174 4.174 0 0 0-1.59-1.883l-.33-.211a4.223 4.223 0 0 1-1.68-2.086 4.225 4.225 0 0 1-.06-2.676l1.12-3.579a1.264 1.264 0 0 0-1.86-1.459c-.26.156-.45.399-.55.685l-.57 1.747c-.16.495-.44.946-.8 1.318a3.41 3.41 0 0 1-2.83 1.002 3.439 3.439 0 0 1-1.46-.521l-11.55-7.445a4.216 4.216 0 0 1-1.67-2.086 4.21 4.21 0 0 1-.06-2.671l2.46-7.836c.28-.887.25-1.842-.07-2.713a4.219 4.219 0 0 0-1.73-2.095l-108.88-66.651a4.198 4.198 0 0 0-2.53-.599l-2.85.238c-.37.031-.75-.027-1.09-.171a2.326 2.326 0 0 1-1.39-1.649 2.44 2.44 0 0 1 .02-1.108c.12-.467.39-.886.75-1.198.37-.312.83-.502 1.31-.545l16.46-1.468a4.157 4.157 0 0 0 2.34-.984 4.167 4.167 0 0 0 1.34-2.16l.42-1.69c.21-.854.15-1.754-.18-2.572a4.095 4.095 0 0 0-1.65-1.977l-18.61-11.656a4.163 4.163 0 0 0-2.48-.628l-12.11.79c-2.83.185-5.01-2.448-4.31-5.196l.75-2.93c.18-.72-.26-1.453-.98-1.633a1.315 1.315 0 0 1-.79-.564c-.19-.281-.26-.62-.21-.952l2.12-13.084c.05-.326.21-.624.46-.848.24-.224.55-.36.88-.387l.08-.006c.35-.03.67-.189.9-.447.24-.257.37-.593.37-.942 0-.497-.26-.958-.69-1.206l-65.76-37.928a4.19 4.19 0 0 1-1.71-1.886 4.226 4.226 0 0 1-.3-2.529l1.28-6.529c.12-.632-.36-1.22-1.01-1.22-.49 0-.91.347-1 .828l-.59 3.032c-.55 2.812-3.69 4.249-6.17 2.818l-8.72-5.028a4.235 4.235 0 0 1-1.69-1.825 4.258 4.258 0 0 1-.35-2.463l.74-4.508a4.15 4.15 0 0 0-2.06-4.302l-124.42-70.559a4.217 4.217 0 0 0-2.35-.533l-60.06 4.088Z"
										/>
									</g>
								</g>
							</svg>
						</picture>
						<span
							className="floor dark stroke"
							style={{
								transform: `translateX(${
									tooltipCoordinate.x - 45
								}px) translateY(${tooltipCoordinate.y - 50}px)`,
								display: `${tooltipShow ? "block" : "none"}`,
							}}
						>
							{tooltipData.building}
						</span>
					</div>
				</div>
			)}
			{isMainPage ? (
				createPortal(<StubContent showVisual={showVisual} />, document.body)
			) : (
				<StubContent showVisual={showVisual} />
			)}
		</>
	);
};

const StubContent = ({ showVisual }) => {
	const isEnglish = document.body.classList.contains("en");

	return (
		<div className="stub">
			<div>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="93"
					height="85"
					viewBox="0 0 93 85"
					fill="none"
				>
					<g clipPath="url(#clip0_2190_23716)">
						<path
							d="M47 33V23.95C47 21.1969 47 19.8204 46.4727 18.7651C45.9888 17.7965 45.2035 17.0112 44.2349 16.5273C43.1796 16 41.8031 16 39.05 16H8.95C6.1969 16 4.82035 16 3.76511 16.5273C2.79654 17.0112 2.01124 17.7965 1.52728 18.7651C1 19.8204 1 21.1969 1 23.95V76.05C1 78.8031 1 80.1796 1.52728 81.2349C2.01124 82.2035 2.79654 82.9888 3.76511 83.4727C4.82035 84 6.1969 84 8.95 84H19"
							stroke="#F9FAFA"
							strokeWidth="2"
							strokeMiterlimit="10"
							strokeLinecap="square"
						/>
						<path
							d="M87 50V65"
							stroke="#F0F0F2"
							strokeWidth="2"
							strokeMiterlimit="10"
							strokeLinecap="square"
						/>
						<path
							d="M87 70V72"
							stroke="#F0F0F2"
							strokeWidth="2"
							strokeMiterlimit="10"
							strokeLinecap="square"
						/>
						<path
							d="M84.05 38C86.8031 38 88.1796 38 89.2349 38.5273C90.2035 39.0112 90.9888 39.7965 91.4727 40.7651C92 41.8204 92 43.1969 92 45.95V76.05C92 78.8031 92 80.1796 91.4727 81.2349C90.9888 82.2035 90.2035 82.9888 89.2349 83.4727C88.1796 84 86.8031 84 84.05 84H31.95C29.1969 84 27.8204 84 26.7651 83.4727C25.7965 82.9888 25.0112 82.2035 24.5273 81.2349C24 80.1796 24 78.8031 24 76.05V45.95C24 43.1969 24 41.8204 24.5273 40.7651C25.0112 39.7965 25.7965 39.0112 26.7651 38.5273C27.8204 38 29.1969 38 31.95 38H84.05Z"
							stroke="#F0F0F2"
							strokeWidth="2"
							strokeMiterlimit="10"
							strokeLinecap="square"
						/>
						<path
							d="M25 10C25 7.20435 25 5.80653 25.4567 4.7039C26.0657 3.23373 27.2337 2.06569 28.7039 1.45672C29.8065 1 31.2044 1 34 1H53.96C57.2637 1 58.9156 1 60.1819 1.63273C61.3442 2.21349 62.2865 3.15585 62.8673 4.31813C63.5 5.58442 63.5 7.23628 63.5 10.54V30"
							stroke="#F0F0F2"
							strokeWidth="2"
							strokeMiterlimit="10"
							strokeLinecap="square"
						/>
						<path
							d="M58 25.4854L63.6569 31.1422L69.3137 25.4854"
							stroke="#F0F0F2"
							strokeWidth="2"
							strokeMiterlimit="10"
							strokeLinecap="square"
						/>
					</g>
					<defs>
						<clipPath id="clip0_2190_23716">
							<rect width="93" height="85" fill="white" />
						</clipPath>
					</defs>
				</svg>
				<p>
					{isEnglish
						? "Rotate the device horizontally to select on the plan."
						: "Поверните устройство в\u00A0горизонтальное положение для\u00A0выбора на\u00A0плане"}
				</p>
			</div>
			<p>
				{isEnglish
					? "or select apartments according to parameters"
					: "или подберите апартаменты по параметрам"}
			</p>
			<button
				className="chooser-type dark stroke"
				onClick={showVisual}
				type="button"
			>
				{isEnglish ? "Select by list" : "Выбрать списком"}
			</button>
		</div>
	);
};
